/* ============================================================================
   nuud US — sticky buy bar
   ----------------------------------------------------------------------------
   Mirrors the buy box's current selection and submits the same form.

   Two things worth knowing:

   1. The reveal is driven by IntersectionObserver watching the buy box, not by
      a scroll handler wrapped in requestAnimationFrame. rAF does not fire in a
      backgrounded tab, which makes an rAF-gated bar look broken under
      automated testing and in background tabs.

   2. The bar toggles `is-visible`, and the CSS in section-sticky.css keys off
      exactly that class. If you rename one, rename both.
   ========================================================================= */
(function () {
  'use strict';

  function boot() {
    var bar = document.querySelector('[data-sticky-bar]');
    var box = document.querySelector('[data-buy-box]');
    if (!bar || !box) return;

    var els = {
      title: bar.querySelector('[data-sticky-title]'),
      sub:   bar.querySelector('[data-sticky-sub]'),
      image: bar.querySelector('[data-sticky-image]'),
      cta:   bar.querySelector('[data-sticky-cta]'),
      price: bar.querySelector('[data-sticky-price]')
    };

    bar.hidden = false;
    document.body.classList.add('has-sticky-bar');

    /* ------------------------------------------------------------- reveal */
    /* Visible whenever the real button is not on screen. That includes first
       paint, while the visitor is still up in the hero: on a phone the button
       is two screens down, and a paid visitor should never have to hunt for it.
       It hides only while the button it duplicates is itself in view, so the
       two never sit on top of each other.

       Watch the BUTTON, not the whole buy box. The box is far taller than a
       phone screen (2,850px on shop-all), so the old "box has scrolled past"
       test kept the bar hidden until the visitor was 3,000px down the page.

       The observer alone is not enough: its first callback can land before the
       gallery's images have sized, when the button is still measured near the
       top and therefore counts as on screen. So set the state from a real rect
       at boot and again on load, and let the observer handle everything after.
       Deliberately not requestAnimationFrame: it does not fire in a
       backgrounded tab, which makes the bar look broken under test. */
    var watch = box.querySelector('[data-submit]') || box;

    function reveal() {
      var r = watch.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var onScreen = r.bottom > 0 && r.top < vh;
      bar.classList.toggle('is-visible', !onScreen);
    }

    reveal();
    window.addEventListener('load', reveal);
    window.addEventListener('resize', reveal);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(watch);
    } else {
      window.addEventListener('scroll', reveal, { passive: true });
    }

    /* ------------------------------------------------------------- mirror */
    function sync(detail) {
      if (!detail || !detail.pack) return;
      var pack = detail.pack;
      if (els.sub)   els.sub.textContent = pack.name + ' · ' + pack.contents;
      if (els.image && pack.image) { els.image.src = pack.image; }

      /* The price is copied from the buy box rather than recomputed, so the
         subscribe price, the cadence and the struck-through welcome discount
         are whatever the buy box is showing. Without it the bar sent people
         into a recurring order with no amount in view. */
      var livePrice = box.querySelector('[data-price]');
      var liveMeta  = box.querySelector('[data-price-meta]');
      if (els.price && livePrice) {
        var meta = liveMeta ? liveMeta.textContent.trim() : '';
        if (!meta && detail.mode === 'onetime') meta = 'one-time';
        els.price.innerHTML = '<b>' + livePrice.innerHTML + '</b>' +
          (meta ? ' <span class="note">' + meta.replace(/[<>&]/g, '') + '</span>' : '');
      }

      var live = box.querySelector('[data-submit]');
      if (els.cta && live) {
        els.cta.textContent = live.textContent;
        els.cta.disabled = live.disabled;
      }
    }

    document.addEventListener('buybox:change', function (e) { sync(e.detail); });

    // Both scripts are deferred, so buy-box.js has already run its first render
    // and fired `buybox:change` before this listener existed. Without this the
    // bar shows its placeholder title and an EMPTY button until the visitor
    // touches the pack picker. Read the state buy-box.js parked on the element.
    sync(box.buyboxState);

    // The bar has no form of its own: it submits the buy box's, so there is
    // exactly one source of truth for what goes in the cart.
    if (els.cta) {
      els.cta.addEventListener('click', function () {
        var form = box.querySelector('[data-buy-form]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
